import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import apiService from '../../services/api'; // 🟢
import UserAvatar from '../common/UserAvatar';

const GamesPage = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loadingLB, setLoadingLB] = useState(true);
  // 🟢 [新增] 错误状态
  const [lbError, setLbError] = useState(false);

  // 🟢 [新增] 获取排行榜数据
  useEffect(() => {
    const fetchLB = async () => {
      try {
        setLbError(false);
        // 这里默认取前 5 名
        const res = await apiService.getLeaderboard('vocab-run', 5);
        setLeaderboard(res.leaderboard || []);
      } catch (e) {
        console.error("Leaderboard fetch failed:", e);
        setLbError(true); // 标记出错
      } finally {
        setLoadingLB(false);
      }
    };
    fetchLB();
  }, []);

  const games = [
    {
      id: 'vocab-run',
      title: 'Vocab Survival', // 🟢 改名：更符合玩法
      description: 'The energy is dropping! Answer quickly to stay in the game.', // 🟢 更新描述
      icon: '⚡', // 🟢 换个图标
      color: 'from-blue-500 to-cyan-400', // 🟢 换个更有科技感的颜色
      features: [
        'Fast-paced survival mode', 
        'Health decays over time', 
        'Correct answers heal you'
      ],
      difficulty: 'Hard', // 🟢 这种模式通常比较刺激
      link: '/games/vocab-run'
    },
    {
      id: 'word-scramble',
      title: 'Word Scramble Challenge',
      description: 'Build words by arranging letter tiles in the correct order!',
      icon: '🔤',
      color: 'from-green-500 to-blue-500',
      features: ['Interactive letter tiles', 'Audio pronunciation', 'Target word hints'],
      difficulty: 'Easy',
      link: '/games/word-scramble'
    },
    {
      id: 'word-search',
      title: 'Word Search Adventure',
      description: 'Find hidden vocabulary words in the puzzle grid!',
      icon: '🔍',
      color: 'from-orange-500 to-red-500',
      features: ['Definition clues', 'Timed challenges', 'Comic backgrounds'],
      difficulty: 'Extreme',
      link: '/games/word-search'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-100 via-sky-200 to-blue-300 p-6">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">🎮 Game Center</h1>
          <p className="text-xl text-gray-700">Learn vocabulary through exciting games!</p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {games.map((game, index) => (
            <motion.div key={game.id} initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: index * 0.2 }} whileHover={{ scale: 1.05, y: -10 }} className="bg-white bg-opacity-20 backdrop-blur-lg rounded-2xl p-8 text-gray-800 shadow-2xl flex flex-col">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">{game.icon}</div>
                <h2 className="text-2xl font-bold mb-2">{game.title}</h2>
                <div className={`inline-block px-3 py-1 rounded-full text-sm font-bold bg-gradient-to-r ${game.color} text-white`}>{game.difficulty}</div>
              </div>
              <p className="text-center mb-6 text-gray-700 flex-grow">{game.description}</p>
              <Link to={game.link} className={`block w-full bg-gradient-to-r ${game.color} hover:opacity-90 text-white font-bold py-4 px-6 rounded-lg text-center shadow-lg`}>Play Now!</Link>
            </motion.div>
          ))}
        </div>

        <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.8 }} className="mt-8 bg-white bg-opacity-30 backdrop-blur-lg rounded-3xl p-8 text-gray-800 shadow-xl border border-white/40">
          <h2 className="text-3xl font-bold text-center mb-8">🏆 Monthly Leaderboard</h2>
          <div className="space-y-4">
              {loadingLB ? <div className="text-center p-8">Loading...</div> : lbError ? <div className="text-center p-4 text-red-600">Failed to load.</div> : leaderboard.length > 0 ? (
                leaderboard.map((entry, idx) => (
                  <motion.div key={idx} initial={{ x: -20, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: idx * 0.1 }} className="flex justify-between items-center bg-white/60 p-4 rounded-2xl shadow-sm border border-white">
                    <div className="flex items-center gap-4">
                      <div className="w-10 text-center text-2xl font-black text-gray-400">{idx + 1}</div>
                      <UserAvatar avatarId={entry.avatarId} inventory={entry.inventory || []} size="sm" className="border-2 border-purple-200" />
                      <div>
                          <div className="font-bold text-gray-800 text-lg">{entry.userName || 'Anonymous'}</div>
                          <div className="text-xs text-gray-500 font-semibold uppercase">{entry.level || 'Core'} Runner</div>
                      </div>
                    </div>
                    <div className="text-right"><span className="font-mono font-black text-2xl text-purple-600">{entry.score}</span><span className="text-xs text-purple-400 font-bold ml-1">PTS</span></div>
                  </motion.div>
                ))
              ) : <div className="text-center py-8">No scores yet.</div>}
            </div>
        </motion.div>
      </div>
    </div>
  );
};

export default GamesPage;
